import request from "../http/request";
//调用微信sdk
export function getAuthInfo(params) {
  return request({
    url: "/api/wechat/wachat/page/auth",
    method: "get",
    params,
  });
}

//查询订单
export function queryOrder(params) {
  return request({
    url: "/api/search/applet/trans/query/latest/custom/rate",
    method: "get",
    params,
    isMassage: true,
  });
}

//申请解冻
export function applyRefund(data) {
  return request({
    url: "/api/proceeds/mer/custom/pricing/refund/apply/byDmCode",
    method: "post",
    data,
    isMassage: true,
  });
}
